/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdSearchList from '@/components/DdSearchGrid'
import DdTextBox from '@/components/DdTextBox'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'
// import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
// import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

export default {
  name: 'PrmHaishaList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdCodeTextBox,
    DdDateBox,
    DdSearchList,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 50,
    page: 1,
    isCsvDownloader: false,
    isExcelDownloader: false,

    // 検索条件
    conditions: {
      unkoYoteiStartYmdString: null,
      unkoYoteiEndYmdString: null,
      haishaEigyoshoId: null,
      tokuisakiId: null,
      hacchusakiId: null,
      jomuinJininId: null,
      sharyoId: null,
      meisaiHeadFlg: false
    },
    conditionDetails: [
      { key: 'sagyoYmdString', name: '対象日', value: 'sagyoYmdString', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'sagyoEigyoshoId', name: '売上営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jininId1', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' }
    ],

    // 検索結果
    rows: [],

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    // 権限
    modeKengen: 0,

    // AG-Gridオプション
    customGridOptions: {
      domLayout: 'normal',
      pagination: true,
      paginationPageSize: 50,
      tooltipShowDelay: 0
    }
  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    viewStyleType () {
      const type = [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditType) ? 1 : this.userSettings.useNippoEditType
      return type
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        const wDate = (filter.dateFormatter(elem.sagyoYmd)).split('/')
        elem.day = wDate[1] + '/' + wDate[2]

        elem.genkaiRieki = ([undefined, null].includes(elem.seikyuKingaku) ? 0 : elem.seikyuKingaku) - ([undefined, null].includes(elem.shiharaiKingaku) ? 0 : elem.shiharaiKingaku)
        if (![undefined, null].includes(elem.seikyuKingaku)) {
          elem.riekiRitsu = (elem.genkaiRieki / elem.seikyuKingaku * 100).toFixed(2)
        }
        elem.hatsuchiDisp = [undefined, null, ''].includes(elem.hatsuchiNm) ? elem.hatsuchiBiko : elem.hatsuchiNm
        elem.chakuchiDisp = [undefined, null, ''].includes(elem.chakuchiNm) ? elem.chakuchiBiko : elem.chakuchiNm

        elem.sagyoYmd = elem.sagyoYmd ? filter.dateFormatter(elem.sagyoYmd) : ''
        elem.seikyuYoteiYmd = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.shiharaiYoteiYmd = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        return elem
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return -1 }
        if (a.unkoYmd === b.unkoYmd) {
          if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
          if (a.trUnkoJissekiId === b.trUnkoJissekiId) {
            if (a.meisaiOrder > b.meisaiOrder) { return 1 }
            if (a.meisaiOrder === b.meisaiOrder) { return 0 }
            return -1
          }
          return 0
        }
        return 1
      })
    },

    // ------------------------------------------------------------
    // マスタ
    // ------------------------------------------------------------
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先フィルター
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === false && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },

    // ------------------------------------------------------------
    // 表示制御
    // ------------------------------------------------------------
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0 || this.isExcelDownloader
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    }
  },
  created () {
    this.params = this.$route.params
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    getNextTransition: function () {
      const nextTransition = ![undefined, null].includes(this.userSettings.useNippoEditTransition) ? this.userSettings.useNippoEditTransition : 1
      return nextTransition
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (self.isNoParam) {
              // 請求一覧画面からパラメータが渡されていない（当画面をリロードした）場合
              // 請求一覧画面から受け取ったパラメータをキャッシュから再現するようにしている
              self.loadFromCache()
                .then((c) => {
                  self.params = c.value.params || {}
                  resolve()
                })
            }
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
              self.params = c.cache.value.params || {}
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            // パラメータがある場合は初期検索を実施する
            if (!self.isNoParam) {
              self.onSearchButtonClick()
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonIgnition: function (e) {
      this.$refs.ddSearchList.onSearchButtonClick()
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.selected = []
      this.page = 1

      // ヘッダ作成
      this.setHeader()

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.conditions.sagyoYoteiEndYmdString = self.conditions.sagyoYmdString
            self.HttpClient.post('/api/v1/VwCD2bzmd0140/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          if ([undefined, null, 0].includes(self.rows.length)) {
            self.$refs.ddSearchList.showConditionArea()
          }

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            meisaiHeadFlg: self.conditions.meisaiHeadFlg
          }
        }
      }
      this.search(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        sagyoYmdString: this.params.sagyoYmd ?? date.getCurrentDate()
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.initBindVariables()
            self.$refs.ddSearchList.showConditionArea()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRemoveConditionClick: function (itemNm, type) {
      if (type === 'checkbox') {
        this.conditions[itemNm] = false
      } else {
        this.conditions[itemNm] = null
      }
    },
    onRowDoubleClick: function (e) {
      console.log(e)
      alert(`AG-GRID DOUBLE CLICK ${this.conditions.targetYm} ${e.day}`)
      // this.Effects.loadStart()
      // this.transition(this.getNextTransition(), { id: [f.item.trUnkoJissekiId, f.item.keikakujissekikey] })
    },

    // 検索前チェック
    searchValidate: function () {
      return true
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },

    // ------------------------------------------------------------------
    // AG-GRID用
    // ------------------------------------------------------------------
    setHeader () {
      this.headers = [
        {
          headerName: `${this.conditions.sagyoYmdString.slice(-5)}`,
          headerClass: 'title-header center-aligned-group-header',
          children: [
            { headerName: '売上営業所', field: 'sagyoEigyoshoNm', sortable: true, width: 110 }
          ]
        },
        {
          headerName: '収益',
          children: [
            {
              headerName: '利益率',
              headerClass: 'revenue-header',
              field: 'riekiRitsu',
              sortable: true,
              width: 80,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toFixed(2).toLocaleString() + ' ％' },
              cellClassRules: {
                'cell-green': (params) => Number(params.value) >= 50,
                'cell-red': (params) => Number(params.value) < 10
              }
            },
            { headerName: '限界利益', field: 'genkaiRieki', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        },
        {
          headerName: '受注',
          children: [
            { headerName: '荷主', field: 'tokuisakiNm', sortable: true, width: 160 },
            { headerName: '発地', field: 'hatsuchiDisp', sortable: true, width: 120 },
            { headerName: '着地', field: 'chakuchiDisp', sortable: true, width: 120 },
            { headerName: '商品', field: 'shohinNm', sortable: true, width: 120 },
            { headerName: '請求予定日', field: 'seikyuYoteiYmd', sortable: true, width: 110, cellStyle: { textAlign: 'center' } },
            { headerName: '請求金額', field: 'seikyuKingaku', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        },
        {
          headerName: '傭車',
          children: [
            { headerName: '傭車先', field: 'hacchusakiNm', sortable: true, width: 160 },
            { headerName: '支払予定日', field: 'shiharaiYoteiYmd', sortable: true, width: 110, cellStyle: { textAlign: 'center' } },
            { headerName: '支払金額', field: 'shiharaiKingaku', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        },
        {
          headerName: '運行',
          children: [
            { headerName: '車両', field: 'jidoshaHyojiNm', sortable: true, width: 120 },
            { headerName: '車種', field: 'shashuSbtNm', sortable: true, width: 120 },
            { headerName: '走行距離', field: 'sokoKyori', sortable: true, width: 100, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' Km' } },
            { headerName: '出庫日', field: 'jissekiShukkoYmd', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '出庫時刻', field: 'jissekiShukkoHms', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '帰庫日', field: 'jissekiKikoYmd', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '帰庫時刻', field: 'jissekiKikoHms', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '拘束時間', field: 'sagyoJikan', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '休憩時間', field: 'kyusokuJikan', sortable: true, width: 100, cellStyle: { textAlign: 'center' } },
            { headerName: '稼働時間', field: 'kadouJikan', sortable: true, width: 100, cellStyle: { textAlign: 'center' } }
          ]
        },
        {
          headerName: '経費',
          children: [
            { headerName: '燃料費', field: 'nenryohi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '交通費', field: 'kotsuhi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: 'その他経費', field: 'sonotaKeihi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        },
        {
          headerName: '管理',
          children: [
            { headerName: '注文番号', field: 'chumonNo', sortable: true, width: 120 },
            { headerName: '受注番号', field: 'juchuNo', sortable: true, width: 120 },
            { headerName: '日報番号', field: 'unkoJissekiNo', sortable: true, width: 120 }
          ]
        }
      ]
    },
    prevNextDate: function (val) {
      this.conditions.sagyoYmdString = val
    },

    onDummyFunction: function () {
      return null
    }
  }
}
